import Button from 'components/ui/Button';
import useProjectCreate from 'hooks/useProjectCreate';
import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 34px;
  font-weight: 700;
  margin-bottom: 20px;
`;

const Description = styled.p`
  font-size: 18px;
  text-align: center;
  white-space: pre-line;
  margin-bottom: 30px;
`;

const Welcome = () => {
  const { onCreateClick } = useProjectCreate();
  return (
    <Container>
      <Title>BlockAI에 오신걸 환영해요</Title>
      <Description>{`BlockAI에선 코딩 없이 AI 모델을 개발할 수 있어요\n지금 바로 프로젝트를 만들어 나만의 AI 모델을 만들어 보세요`}</Description>
      <Button $width={240} $height={50} $fontSize={18} onClick={onCreateClick}>
        새 프로젝트 만들기
      </Button>
    </Container>
  );
};

export default Welcome;
